import { Stage } from '../courses';
import { CourseAssignment } from './@types';
import { CommonRequestOptions, makeRequest } from '../makeRequest';

export type StageCompletionRecord = {
   course_stageid: number;
   doc_url: string;
   due_date: number | null;
   last_completion: null | {
      docid: number;
      doctype: string;
      init_date: number;
      end_date: number;
      work_log_entryid: number | null;
   };
   percentage?: number;
   completions?: number;
   total_members?: number;
   quiz_attempts_remaining?: number;
   manager_override_userid: null;
   stage: Stage;
   status: StageStatus;
   doc_status: StageStatus;
   title: string;
   assessments: AssessmentCompletion[];
};

type SignOffCompletion = {
   stage_assessmentid: number;
   assessmenttype: 'trainer-sign-off';
   trainer_signoff_requestid: number;
   is_completed: boolean;
   teamid_signer: number;
   signoff_request: {
      signoff_requestid: number;
      response_value: boolean;
      response_feedback: string;
      response_acknowledged: boolean;
      created_at: number;
      completed_at: number;
      acknowledged_at: number;
      requestor: {
         userid: number;
         username: string;
         userAvatar: string;
         userProfile: string;
      };
      requestee: {
         userid: number;
         username: string;
         userAvatar: string;
         userProfile: string;
      };
   };
};

type QuizCompletion = {
   stage_assessmentid: number;
   assessmenttype: 'quiz';
   is_completed: boolean;
};

export type AssessmentCompletion = SignOffCompletion | QuizCompletion;

export type StageStatus = 'pending' | 'completed' | 'expired' | 'invalidated' | 'started';

export type GetCourseAssignmentUserDetailsOptions = CommonRequestOptions & {
   withCompletion?: boolean;
};

export type GetCourseAssignmentTeamDetailsOptions = CommonRequestOptions & {
   withCompletion?: boolean;
};

export async function getCourseAssignmentUserDetails(
   course_assignmentid: number,
   { withCompletion, ...common }: GetCourseAssignmentUserDetailsOptions = {}
): Promise<CourseAssignment> {
   return makeRequest('get', `/course_assignments/${course_assignmentid}`, {
      ...common,
      query: {
         withCompletion,
      },
   });
}

export async function getCourseAssignmentTeamDetails(
   course_assignmentid: number,
   { withCompletion, ...common }: GetCourseAssignmentTeamDetailsOptions = {}
): Promise<CourseAssignment> {
   return makeRequest('get', `/course_assignments/team/${course_assignmentid}`, {
      ...common,
      query: {
         withCompletion,
      },
   });
}
